<template>
  <div>
    <div v-if="props.modelValue" class="video-box-src">
      <video :src="props.modelValue" controls style="width: 160px; height: 160px"></video>
      <svg-icon class="icon" name="close" @click.stop="delVideo"></svg-icon>
    </div>
    <div
      style="display: flex; flex-direction: column"
      v-else
      class="video-box"
      @click="() => handleUpload()"
      v-loading="uploading"
      element-loading-text="上传中...">
      <el-icon :size="20" color="#949ca2">
        <VideoCamera />
      </el-icon>
      <div style="color: #949ca2">{{ props.title }}</div>
    </div>
    <div style="color: #949ca2; font-size: 13px">{{ props.desc }}</div>
    <input ref="inputRef" class="hidden" type="file" @change="handleFileChange" />
    <!--上传-->
    <!--<el-upload-->
    <!--    ref="uploadRef"-->
    <!--    :action="proxyUrl + '/sys/getUploadToken'"-->
    <!--    :before-upload="beforeUpload"-->
    <!--    :headers="{ Authorization: 'Bearer ' + token }"-->
    <!--    :on-error="onError"-->
    <!--    :on-success="handleSuccess"-->
    <!--    :show-file-list="false"-->
    <!--    accept=".mp4"-->
    <!--    class="hidden"-->
    <!--    name="file"></el-upload>-->
  </div>
</template>

<script lang="ts" setup>
// 上传视频
import { reactive, ref, watch } from 'vue'
import { ElMessage } from 'element-plus'
import api from '@/api/common'

interface IProps {
  modelValue: string
  title?: string
  multiple?: boolean
  max?: number
  width?: number
  height?: number
  desc?: string
  limit?: number
}

const props = withDefaults(defineProps<IProps>(), {
  multiple: false,
  max: 5,
  width: 80,
  height: 80,
  limit: 2
})
const emits = defineEmits(['update:modelValue', 'change'])
// 上传相关方法
const handleUpload = () => {
  if (inputRef.value) {
    inputRef.value.click()
  }
}

const initForm = {
  width: undefined,
  height: undefined,
  duration: undefined,
  size: undefined,
  name: undefined,
  url: undefined
}

const form = reactive({ ...initForm })
const inputRef = ref(null)
const uploading = ref(false)
const handleFileChange = async (e: any) => {
  console.log(e, 88888)

  const selectedFile = e.target.files[0]
  console.log('object :>> ', selectedFile)

  if (!['video/mp4'].includes(selectedFile.type)) {
    ElMessage.warning('请选择 video/mp4 类型的文件')
    return
  }
  const maxSize = 100 * 1024 * 1024
  if (selectedFile.size > maxSize) {
    ElMessage.warning('视频文件大小不能超过100MB')
    return
  }
  // 获取视频信息 - 使用 Promise 包装
  const getVideoInfo = (file) => {
    return new Promise((resolve) => {
      const video = document.createElement('video')
      video.preload = 'metadata'
      video.onloadedmetadata = () => {
        form.width = video.videoWidth
        form.height = video.videoHeight
        form.duration = video.duration
        form.size = file.size
        form.name = file.name
        URL.revokeObjectURL(video.src) // 释放 URL
        resolve(form)
      }
      video.src = URL.createObjectURL(file)
    })
  }
  uploading.value = true
  await getVideoInfo(selectedFile)

  // 准备上传 - 确保 FormData 正确创建
  const formData = new FormData()
  formData.append('file', selectedFile)

  // 验证 FormData 内容
  console.log('FormData entries:')
  for (let [key, value] of formData.entries()) {
    console.log(key, value)
  }

  const res = await api.uploadFile(formData)
  if (res.success) {
    const uploadData = res.data

    form.url = `${uploadData.file_url}`
    emits('change', form)
    emits('update:modelValue', form.url)

    console.info('🚀 ~ uploadData:', uploadData)
    console.info('🚀 ~ form.url:', form.url)
  }
  uploading.value = false
}
const delVideo = () => {
  emits('change', null)
  emits('update:modelValue', '')
}

watch(
  () => props.modelValue,
  (newVal, oldVal) => {
    if (!newVal) {
      Object.assign(form, initForm)
      inputRef.value = null
    }
  }
)
</script>

<style lang="scss" scoped>
.video-box {
  width: 160px;
  height: 100px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e9ebf0;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.video-box-src {
  display: flex;

  .icon {
    margin-left: -10px;
    margin-top: -5px;
    z-index: 1000;
    color: #f53f3f;
    cursor: pointer;
  }
}
</style>
